import { render, staticRenderFns } from "./FooterDark.vue?vue&type=template&id=a07cdd14&scoped=true&"
import script from "./FooterDark.vue?vue&type=script&lang=js&"
export * from "./FooterDark.vue?vue&type=script&lang=js&"
import style0 from "./FooterDark.vue?vue&type=style&index=0&id=a07cdd14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07cdd14",
  null
  
)

export default component.exports